export default function convertUnicode(input) {
    return input.replace(/&#(\w\w\w);/g,function(a) {
        let charcode = a.substr(2, 3);
        return String.fromCharCode(charcode);
    });
}
